import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
import {HeaderService} from '../../service/header.service';
import {PlatformService} from '../../service/platform.service';
import {LoggerService} from '../../service/logger.service';
import {SecurityContextHolder} from '../../security/context/security-context-holder';
import {ActivationEnd, Router} from '@angular/router';
import {IPrincipal} from '../../security/context/principal';
import {environment} from '../../../environments/environment';
import {IOrganization} from '../../data/organization/organization.model';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false
})
export class LayoutComponent implements AfterViewInit
{
  header: string = '';
  organizationId!: string;
  organizationName!: string
  selector!: string;
  version!: string;
  principal!: IPrincipal;
  copyRightYear!: number;

  openLogoutModal: boolean = false;
  openSupportModal: boolean = false;
  organizations: IOrganization[] = [];

  constructor(private headerService: HeaderService,
              private logger: LoggerService,
              private securityContextHolder: SecurityContextHolder,
              private router: Router,
              private elementRef: ElementRef,
              public platformService: PlatformService) {
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
    this.version = environment.version;
    if (this.securityContextHolder?.context?.principal) {
      this.principal = securityContextHolder.context.principal;
    }
    this.copyRightYear = new Date().getFullYear();
  }

  ngAfterViewInit(): void
  {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        const oIdStr = event.snapshot.paramMap.get('organization-id');
        if (oIdStr)
        {
          this.organizationId = oIdStr;
          this.loadData();
        }
      }
    });
    this.headerService.headerChanged.subscribe((header: string) => {
      this.header = header;
    });
  }

  async loadData()
  {
    this.logger.info('Loading Data in Layout Component');
    this.organizations = this.securityContextHolder.organizations;
    for (const organization of this.organizations) {
      if (organization.id === this.organizationId) {
        this.logger.info('Organization found: ' + organization.name);
        this.organizationName = organization.name;
        break;
      }
    }
  }

  onOpenLogoutModal(open: boolean) {
    this.openLogoutModal = open;
  }

  onOpenSupportModal(open: boolean) {
    this.openSupportModal = open;
  }

  changeOrganization(organizationId: string) {
    const newUrl = `${window.location.origin}/#/org/${organizationId}/queue`;
    window.open(newUrl, '_blank');
  }
}
